/* eslint-disable */
export default {
  add: 'Add',
  replaceAll: 'ReplaceAll',
  removeExact: 'RemoveExact',
  removeContaining: 'RemoveContaining',
  removeAll: 'RemoveAll'
};

